// Card.js
import React from "react";

function Card({ children, className , onClick}) {
  return (
    <div onClick={onClick}
      className={
         ` bg-sunny-primary dark:text-dark-text dark:bg-dark-primary shadow-lg rounded-lg ${className}`
      }
    >
      {children}
    </div>
  );
}

export default Card;
